export enum PropertyConfiguratorStep {
    LOCATION = 1,
    ROOMS = 2,
    BUDGET = 3,
    RESULTS = 4
}
export enum PropertyConfiguratorStep {
    LOCATION = 1,
    ROOMS = 2,
    BUDGET = 3,
    RESULTS = 4
}
